<template>
  <div>
    <main-layout>
      <v-container>
        <v-tabs
          v-model="viewPage"
          color="white"
          :slider-color="$vuetify.theme.primary"
          style="font-size: 18px"
        >
          <v-tab
            v-for="(item, index) in menuData"
            :key="`menu-item-${index}`"
            style="text-transform: capitalize"
            ripple
            :href="`#${item.view}`"
            @click="updateSlug(item.view)"
            >{{ item.text }}</v-tab
          >
        </v-tabs>
        <div>
          <div id="view-content-techhunt" class="mt-4">
            <VoucherStatus v-if="view == 'voucherStatus'" />
            <ApproveVoucher v-if="view == 'approveVoucher'" />
            <Byagecy v-if="view == 'byagecy'" />
            <!-- <Byprovince v-if="view == 'byprovince'" /> -->
          </div>
        </div>
      </v-container>
    </main-layout>
  </div>
</template>

<script>
// import Campaign from './Campaign'
import VoucherStatus from './voucherStatus.vue'
import ApproveVoucher from './approveVoucher.vue'
import Byagecy from './byagecy.vue'
import Byprovince from './byprovince.vue'

export default {
  components: { VoucherStatus, ApproveVoucher, Byagecy, Byprovince },
  data() {
    return {
      menuData: [
        {
          text: this.$t('สถานะคูปอง'),
          view: 'voucherStatus'
        },
        {
          text: this.$t('จำนวนการขอคูปอง'),
          view: 'byagecy'
        },
        // {
        //   text: this.$t('ตามจังหวัด'),
        //   view: 'byprovince'
        // },
        {
          text: this.$t('คูปองที่อนุมัติแล้ว'),
          view: 'approveVoucher'
        }
      ],
      viewPage: 'voucherStatus'
    }
  },
  mounted() {},
  computed: {
    view() {
      var defaultview = 'voucherStatus'
      //   if (this.$store.state.privilege && this.$store.state.privilege.role == 'agency') {
      //     defaultview = 'couponreport'
      //   }
      this.viewPage = this.$route.query.view ? this.$route.query.view : defaultview
      return this.$route.query.view ? this.$route.query.view : defaultview
    }
  },
  methods: {
    updateSlug(view) {
      if (view !== this.view) {
        this.$router.replace({ query: { view } })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.border-bot {
  border-bottom: 2px solid #152d53;
}
</style>



// WEBPACK FOOTER //
// src/components/view/voucherreport/main.vue